import MDynamicSelect from "./MDynamicSelect.vue";
export default MDynamicSelect;
